import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CategoryFilter } from '@msc-b2c/interfaces/types';
import { MyAreaFilterState } from '@msc-b2c/interfaces/interfaces';

const initialState: MyAreaFilterState = {
  categoryFilters: {
    initial: [],
    filtered: [],
    applied: [],
  },
  showFilterDrawer: false,
  isButtonsDisabled: true,
};

const myAreaFilterSlice = createSlice({
  name: 'myAreaFilter',
  initialState,
  reducers: {
    triggerFilterClearing(state) {
      if (state.categoryFilters) {
        state.categoryFilters.filtered = state.categoryFilters?.filtered?.map((categoryFilter) => {
          return { ...categoryFilter, checked: false };
        });
        state.isButtonsDisabled = state.categoryFilters?.applied?.length == 0;
      }
    },
    triggerFilterApplication(state) {
      // put the checked filters into the applied filters
      if (state.categoryFilters)
        state.categoryFilters.applied = state.categoryFilters?.filtered?.filter(
          (categoryFilter) => categoryFilter.checked
        );
      state.showFilterDrawer = false;
      state.isButtonsDisabled = state.categoryFilters?.applied?.length == 0;
    },
    triggerOpenFilterDrawer(state, action: PayloadAction<boolean>) {
      state.showFilterDrawer = action.payload;
    },
    initialCategoryFilters(state, action: PayloadAction<CategoryFilter[]>) {
      if (state.categoryFilters) state.categoryFilters.initial = action.payload;
    },
    categoryFiltersSpecificDay(state, action: PayloadAction<CategoryFilter[]>) {
      // for each item if there was already checked, keep it checked
      if (state.categoryFilters)
        state.categoryFilters.filtered = action.payload.map((categoryFilter) => {
          const existingFilter = state.categoryFilters?.filtered?.find(
            (filter) => filter.filterLabel === categoryFilter.filterLabel
          );
          return existingFilter ? existingFilter : categoryFilter;
        });
    },
    toggleCategoryFilter(state, action: PayloadAction<number>) {
      const index = action.payload;
      if (
        state.categoryFilters?.filtered &&
        index >= 0 &&
        index < state.categoryFilters?.filtered.length
      ) {
        const currentFilter = state.categoryFilters?.filtered[index];
        state.categoryFilters.filtered[index].checked = !currentFilter.checked;
        state.isButtonsDisabled =
          state.categoryFilters.applied?.length != 0
            ? false
            : !state.categoryFilters.filtered.some((filter) => filter.checked);
      }
    },
    syncAppliedToFiltered(state) {
      //categoryFilters.filtered is getting synced with categoryFilters.applied
      if (state.categoryFilters && state.categoryFilters.applied) {
        const appliedFilters: { [key: string]: boolean | undefined } = {};

        state.categoryFilters.applied.forEach((filter) => {
          appliedFilters[filter.filterType] = filter.checked;
        });

        state.categoryFilters.filtered = state.categoryFilters.filtered.map((filter) => ({
          ...filter,
          checked:
            appliedFilters[filter.filterType] !== undefined
              ? appliedFilters[filter.filterType]
              : false,
        }));
      }
    },
  },
});

export const {
  triggerFilterClearing,
  triggerFilterApplication,
  triggerOpenFilterDrawer,
  initialCategoryFilters,
  categoryFiltersSpecificDay,
  toggleCategoryFilter,
  syncAppliedToFiltered,
} = myAreaFilterSlice.actions;
export default myAreaFilterSlice.reducer;
